// User-Agent
$(() => {
  setTimeout(() => {
    if (/\/u\/c/.test(window.location.pathname)) {
      axios.get(`/xhr/ua?w=${window.screen.width}&h=${window.screen.height}&pd=${window.screen.pixelDepth}&href=${encodeURI(window.location.href).replace(/#.*/g, '')}&referer=${encodeURI(document.referrer).replace(/#.*/g, '')}`)
        .then(response => {
          // console.error('ua', response.data)
          // console.error(response);
        })
        .catch(error => {
          console.error('error', error);
        });
    }
  }, 3000);
});